export default function HeroSection() {
  const scrollTo = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=A%20dreamy%20artistic%20illustration%20of%20floating%20colorful%20comic%20panels%20and%20speech%20bubbles%20drifting%20through%20a%20warm%20atmospheric%20space%20with%20soft%20coral%20and%20amber%20gradient%20background%20stylized%20manga%20and%20webtoon%20art%20elements%20subtle%20ink%20brush%20strokes%20magical%20reading%20atmosphere%20editorial%20composition%20with%20depth%20warm%20inviting%20lighting%20cinematic%20feel&width=1600&height=900&seq=hero-bg-manga&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full text-sm font-medium text-primary-200 mb-5">
              韩漫国漫日漫 · 全集免费下拉式阅读
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-black text-background-50 leading-tight mb-4">
              咻咻漫画
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-[2.8rem] font-bold text-background-50/90 mt-1">
                全集漫画一站式阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl font-heading text-accent-300 font-medium mb-6">
              告别追更等待，全集免费畅读
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              咻咻漫画为您汇集超过<strong className="text-background-50 font-semibold">17000部完结漫画</strong>，涵盖韩漫全集、国漫全集与日漫经典佳作。独创下拉式阅读技术，所有话数无缝衔接，滚动即读，告别点击翻页的繁琐。每日持续更新入库，热门完结第一时间上架，让你追漫快人一步。无论你是韩漫甜宠控、国漫热血粉还是日漫经典收藏家，这里都有属于你的阅读节奏。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">17,000+</span>
                <span className="text-xs text-background-300/80">完结作品</span>
              </div>
              <div className="w-px h-8 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">50+话/日</span>
                <span className="text-xs text-background-300/80">持续更新</span>
              </div>
              <div className="w-px h-8 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-400">99.2%</span>
                <span className="text-xs text-background-300/80">读者好评</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all text-base whitespace-nowrap cursor-pointer text-center"
              >
                开始阅读 <i className="ri-arrow-right-line ml-1.5"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/20 text-background-50 font-medium rounded-lg transition-all text-base whitespace-nowrap cursor-pointer text-center"
              >
                查看热门 <i className="ri-fire-line ml-1.5"></i>
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[400px] lg:max-w-[460px]">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20composition%20of%20floating%20colorful%20comic%20book%20covers%20and%20manga%20panels%20in%20Korean%20manhwa%20Japanese%20manga%20and%20Chinese%20manhua%20styles%20overlapping%20dynamically%20with%20vibrant%20warm%20coral%20amber%20and%20cream%20color%20palette%20magical%20floating%20effect%20soft%20dramatic%20lighting%20premium%20editorial%20look%20clean%20dark%20warm%20background&width=920&height=1100&seq=hero-main-manga&orientation=portrait"
                alt="咻咻漫画平台主视觉 - 韩漫国漫日漫全集展示"
                className="relative rounded-2xl w-full h-auto object-cover"
                width="460"
                height="550"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}